import { PropsWithChildren } from 'react';

import { useAppSelector } from '@/store/hooks';
import { selectActiveChannel } from '@/store/slices/user/selectors';
import isGlobalTemplatesActiveChannel from './helpers/is-global-templates-active-channel';

const GlobalTemplatesChannelGuard = ({ children }: PropsWithChildren<unknown>) => {
  const activeChannel = useAppSelector(selectActiveChannel);

  if (!activeChannel || !isGlobalTemplatesActiveChannel(activeChannel)) {
    return null;
  }
  return <>{children}</>;
};

export default GlobalTemplatesChannelGuard;
